import { SVGProps } from 'react';
const SvgChevronRightDuo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m13 8 4 4-4 4M7 8l4 4-4 4"
    />
  </svg>
);
export default SvgChevronRightDuo;
